import * as React from "react";
const SvgLocation24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 23,
        fill: "black",
        viewBox: "0 0 18 23"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5.1 3.426a6.99 6.99 0 0 1 7.798 0c3.56 2.393 4.146 7.397 1.235 10.547L9 19.527l-5.134-5.554C.955 10.823 1.54 5.819 5.1 3.426Zm8.914-1.66a8.99 8.99 0 0 0-10.03 0C-.594 4.845-1.347 11.28 2.397 15.33L9 22.473l6.601-7.142c3.744-4.051 2.991-10.487-1.587-13.564ZM7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM9 5.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z",
      clipRule: "evenodd"
    })
  );
export default SvgLocation24Px;
